import * as React from "react";
function SvgIcSearch(props) {
  return <svg width="1em" height="1em" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M9.233 3.458a4.083 4.083 0 10-5.775 5.775 4.083 4.083 0 005.775-5.775zm-6.6-.825a5.25 5.25 0 017.815 6.99l2.085 2.085-.825.825-2.085-2.085a5.25 5.25 0 01-6.99-7.815z" fill="currentColor" /></svg>;
}
export default SvgIcSearch;